const privacyNoticeStructure = [
  {
    "number": 1,
    "titleId": "privacy.section1.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section1.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section1.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section1.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section1.paragraph4"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section1.list1.item1",
          "privacy.section1.list1.item2",
          "privacy.section1.list1.item3",
          "privacy.section1.list1.item4"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section1.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section1.paragraph6"
      },
      {
        "type": "paragraph",
        "id": "privacy.section1.paragraph7"
      }
    ]
  },
  {
    "number": 2,
    "titleId": "privacy.section2.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph6"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph7"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph8"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph9"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph10"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph11"
      },
      {
        "type": "paragraph",
        "id": "privacy.section2.paragraph12"
      }
    ]
  },
  {
    "number": 3,
    "titleId": "privacy.section3.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section3.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section3.paragraph2"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section3.list1.item1",
          "privacy.section3.list1.item2",
          "privacy.section3.list1.item3",
          "privacy.section3.list1.item4",
          "privacy.section3.list1.item5",
          "privacy.section3.list1.item6",
          "privacy.section3.list1.item7"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section3.paragraph3"
      }
    ]
  },
  {
    "number": 4,
    "titleId": "privacy.section4.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph3"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section4.list1.item1",
          "privacy.section4.list1.item2",
          "privacy.section4.list1.item3",
          "privacy.section4.list1.item4",
          "privacy.section4.list1.item5",
          "privacy.section4.list1.item6",
          "privacy.section4.list1.item7",
          "privacy.section4.list1.item8",
          "privacy.section4.list1.item9"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph6"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section4.list2.item1",
          "privacy.section4.list2.item2",
          "privacy.section4.list2.item3",
          "privacy.section4.list2.item4",
          "privacy.section4.list2.item5",
          "privacy.section4.list2.item6",
          "privacy.section4.list2.item7",
          "privacy.section4.list2.item8",
          "privacy.section4.list2.item9",
          "privacy.section4.list2.item10",
          "privacy.section4.list2.item11",
          "privacy.section4.list2.item12",
          "privacy.section4.list2.item13",
          "privacy.section4.list2.item14",
          "privacy.section4.list2.item15",
          "privacy.section4.list2.item16"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph7"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph8"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph9"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section4.list3.item1",
          "privacy.section4.list3.item2",
          "privacy.section4.list3.item3",
          "privacy.section4.list3.item4",
          "privacy.section4.list3.item5",
          "privacy.section4.list3.item6",
          "privacy.section4.list3.item7",
          "privacy.section4.list3.item8",
          "privacy.section4.list3.item9",
          "privacy.section4.list3.item10"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph10"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph11"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph12"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph13"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph14"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph15"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph16"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section4.list4.item1",
          "privacy.section4.list4.item2",
          "privacy.section4.list4.item3",
          "privacy.section4.list4.item4",
          "privacy.section4.list4.item5"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph17"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph18"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section4.list5.item1",
          "privacy.section4.list5.item2",
          "privacy.section4.list5.item3",
          "privacy.section4.list5.item4",
          "privacy.section4.list5.item5",
          "privacy.section4.list5.item6",
          "privacy.section4.list5.item7",
          "privacy.section4.list5.item8",
          "privacy.section4.list5.item9",
          "privacy.section4.list5.item10",
          "privacy.section4.list5.item11"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph19"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph20"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section4.list6.item1",
          "privacy.section4.list6.item2",
          "privacy.section4.list6.item3",
          "privacy.section4.list6.item4",
          "privacy.section4.list6.item5",
          "privacy.section4.list6.item6",
          "privacy.section4.list6.item7",
          "privacy.section4.list6.item8"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph21"
      },
      {
        "type": "paragraph",
        "id": "privacy.section4.paragraph22"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section4.list7.item1",
          "privacy.section4.list7.item2",
          "privacy.section4.list7.item3",
          "privacy.section4.list7.item4",
          "privacy.section4.list7.item5",
          "privacy.section4.list7.item6",
          "privacy.section4.list7.item7"
        ]
      }
    ]
  },
  {
    "number": 5,
    "titleId": "privacy.section5.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph3"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section5.list1.item1",
          "privacy.section5.list1.item2",
          "privacy.section5.list1.item3",
          "privacy.section5.list1.item4",
          "privacy.section5.list1.item5",
          "privacy.section5.list1.item6",
          "privacy.section5.list1.item7",
          "privacy.section5.list1.item8"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph6"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph7"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph8"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph9"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph10"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph11"
      },
      {
        "type": "paragraph",
        "id": "privacy.section5.paragraph12"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section5.list2.item1",
          "privacy.section5.list2.item2",
          "privacy.section5.list2.item3",
          "privacy.section5.list2.item4",
          "privacy.section5.list2.item5",
          "privacy.section5.list2.item6",
          "privacy.section5.list2.item7",
          "privacy.section5.list2.item8"
        ]
      }
    ]
  },
  {
    "number": 6,
    "titleId": "privacy.section6.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph3"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list1.item1",
          "privacy.section6.list1.item2",
          "privacy.section6.list1.item3",
          "privacy.section6.list1.item4",
          "privacy.section6.list1.item5",
          "privacy.section6.list1.item6"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph5"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list2.item1",
          "privacy.section6.list2.item2",
          "privacy.section6.list2.item3",
          "privacy.section6.list2.item4",
          "privacy.section6.list2.item5",
          "privacy.section6.list2.item6",
          "privacy.section6.list2.item7"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph6"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph7"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list3.item1",
          "privacy.section6.list3.item2",
          "privacy.section6.list3.item3",
          "privacy.section6.list3.item4",
          "privacy.section6.list3.item5",
          "privacy.section6.list3.item6",
          "privacy.section6.list3.item7"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph8"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph9"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list4.item1",
          "privacy.section6.list4.item2",
          "privacy.section6.list4.item3",
          "privacy.section6.list4.item4",
          "privacy.section6.list4.item5",
          "privacy.section6.list4.item6"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph10"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph11"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph12"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list5.item1",
          "privacy.section6.list5.item2",
          "privacy.section6.list5.item3",
          "privacy.section6.list5.item4",
          "privacy.section6.list5.item5",
          "privacy.section6.list5.item6"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph13"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph14"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph15"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list6.item1",
          "privacy.section6.list6.item2",
          "privacy.section6.list6.item3",
          "privacy.section6.list6.item4",
          "privacy.section6.list6.item5",
          "privacy.section6.list6.item6",
          "privacy.section6.list6.item7"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph16"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph17"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list7.item1",
          "privacy.section6.list7.item2",
          "privacy.section6.list7.item3",
          "privacy.section6.list7.item4",
          "privacy.section6.list7.item5",
          "privacy.section6.list7.item6",
          "privacy.section6.list7.item7"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph18"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph19"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list8.item1",
          "privacy.section6.list8.item2",
          "privacy.section6.list8.item3",
          "privacy.section6.list8.item4",
          "privacy.section6.list8.item5",
          "privacy.section6.list8.item6"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph20"
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph21"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section6.list9.item1",
          "privacy.section6.list9.item2",
          "privacy.section6.list9.item3",
          "privacy.section6.list9.item4",
          "privacy.section6.list9.item5",
          "privacy.section6.list9.item6",
          "privacy.section6.list9.item7"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section6.paragraph22"
      }
    ]
  },
  {
    "number": 7,
    "titleId": "privacy.section7.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph5"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section7.list1.item1",
          "privacy.section7.list1.item2",
          "privacy.section7.list1.item3",
          "privacy.section7.list1.item4",
          "privacy.section7.list1.item5",
          "privacy.section7.list1.item6",
          "privacy.section7.list1.item7",
          "privacy.section7.list1.item8"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph6"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph7"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph8"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph9"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph10"
      },
      {
        "type": "paragraph",
        "id": "privacy.section7.paragraph11"
      }
    ]
  },
  {
    "number": 8,
    "titleId": "privacy.section8.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section8.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section8.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section8.paragraph3"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section8.list1.item1",
          "privacy.section8.list1.item2",
          "privacy.section8.list1.item3",
          "privacy.section8.list1.item4",
          "privacy.section8.list1.item5",
          "privacy.section8.list1.item6",
          "privacy.section8.list1.item7",
          "privacy.section8.list1.item8",
          "privacy.section8.list1.item9"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section8.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section8.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section8.paragraph6"
      }
    ]
  },
  {
    "number": 9,
    "titleId": "privacy.section9.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section9.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section9.paragraph2"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section9.list1.item1",
          "privacy.section9.list1.item2",
          "privacy.section9.list1.item3",
          "privacy.section9.list1.item4",
          "privacy.section9.list1.item5"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section9.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section9.paragraph4"
      }
    ]
  },
  {
    "number": 10,
    "titleId": "privacy.section10.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section10.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section10.paragraph2"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section10.list1.item1",
          "privacy.section10.list1.item2",
          "privacy.section10.list1.item3",
          "privacy.section10.list1.item4",
          "privacy.section10.list1.item5",
          "privacy.section10.list1.item6",
          "privacy.section10.list1.item7",
          "privacy.section10.list1.item8"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section10.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section10.paragraph4"
      }
    ]
  },
  {
    "number": 11,
    "titleId": "privacy.section11.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section11.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section11.paragraph2"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section11.list1.item1",
          "privacy.section11.list1.item2",
          "privacy.section11.list1.item3",
          "privacy.section11.list1.item4",
          "privacy.section11.list1.item5",
          "privacy.section11.list1.item6",
          "privacy.section11.list1.item7"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section11.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section11.paragraph4"
      }
    ]
  },
  {
    "number": 12,
    "titleId": "privacy.section12.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section12.paragraph1"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section12.list1.item1",
          "privacy.section12.list1.item2",
          "privacy.section12.list1.item3",
          "privacy.section12.list1.item4",
          "privacy.section12.list1.item5",
          "privacy.section12.list1.item6"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section12.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section12.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section12.paragraph4"
      }
    ]
  },
  {
    "number": 13,
    "titleId": "privacy.section13.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph6"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph7"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph8"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph9"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph10"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section13.list1.item1",
          "privacy.section13.list1.item2",
          "privacy.section13.list1.item3",
          "privacy.section13.list1.item4",
          "privacy.section13.list1.item5",
          "privacy.section13.list1.item6",
          "privacy.section13.list1.item7",
          "privacy.section13.list1.item8",
          "privacy.section13.list1.item9",
          "privacy.section13.list1.item10"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph11"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph12"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section13.list2.item1",
          "privacy.section13.list2.item2",
          "privacy.section13.list2.item3",
          "privacy.section13.list2.item4",
          "privacy.section13.list2.item5",
          "privacy.section13.list2.item6"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph13"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph14"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph15"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph16"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph17"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph18"
      },
      {
        "type": "paragraph",
        "id": "privacy.section13.paragraph19"
      }
    ]
  },
  {
    "number": 14,
    "titleId": "privacy.section14.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section14.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section14.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section14.paragraph3"
      }
    ]
  },
  {
    "number": 15,
    "titleId": "privacy.section15.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section15.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section15.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section15.paragraph3"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section15.list1.item1",
          "privacy.section15.list1.item2",
          "privacy.section15.list1.item3",
          "privacy.section15.list1.item4",
          "privacy.section15.list1.item5"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section15.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section15.paragraph5"
      }
    ]
  },
  {
    "number": 16,
    "titleId": "privacy.section16.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section16.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section16.paragraph2"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section16.list1.item1",
          "privacy.section16.list1.item2",
          "privacy.section16.list1.item3",
          "privacy.section16.list1.item4",
          "privacy.section16.list1.item5",
          "privacy.section16.list1.item6",
          "privacy.section16.list1.item7",
          "privacy.section16.list1.item8",
          "privacy.section16.list1.item9",
          "privacy.section16.list1.item10"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section16.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section16.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section16.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section16.paragraph6"
      }
    ]
  },
  {
    "number": 17,
    "titleId": "privacy.section17.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section17.paragraph1"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section17.list1.item1",
          "privacy.section17.list1.item2",
          "privacy.section17.list1.item3",
          "privacy.section17.list1.item4",
          "privacy.section17.list1.item5",
          "privacy.section17.list1.item6",
          "privacy.section17.list1.item7"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section17.paragraph2"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section17.list2.item1",
          "privacy.section17.list2.item2",
          "privacy.section17.list2.item3",
          "privacy.section17.list2.item4",
          "privacy.section17.list2.item5",
          "privacy.section17.list2.item6",
          "privacy.section17.list2.item7",
          "privacy.section17.list2.item8"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section17.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section17.paragraph4"
      }
    ]
  },
  {
    "number": 18,
    "titleId": "privacy.section18.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section18.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section18.paragraph2"
      }
    ]
  },
  {
    "number": 19,
    "titleId": "privacy.section19.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section19.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section19.paragraph2"
      }
    ]
  },
  {
    "number": 20,
    "titleId": "privacy.section20.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section20.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section20.paragraph2"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section20.list1.item1",
          "privacy.section20.list1.item2",
          "privacy.section20.list1.item3",
          "privacy.section20.list1.item4",
          "privacy.section20.list1.item5",
          "privacy.section20.list1.item6",
          "privacy.section20.list1.item7",
          "privacy.section20.list1.item8",
          "privacy.section20.list1.item9"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section20.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section20.paragraph4"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section20.list2.item1",
          "privacy.section20.list2.item2",
          "privacy.section20.list2.item3",
          "privacy.section20.list2.item4",
          "privacy.section20.list2.item5",
          "privacy.section20.list2.item6"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section20.paragraph5"
      }
    ]
  },
  {
    "number": 21,
    "titleId": "privacy.section21.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph6"
      },
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph7"
      },
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph8"
      },
      {
        "type": "paragraph",
        "id": "privacy.section21.paragraph9"
      }
    ]
  },
  {
    "number": 22,
    "titleId": "privacy.section22.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section22.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section22.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section22.paragraph3"
      }
    ]
  },
  {
    "number": 23,
    "titleId": "privacy.section23.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section23.paragraph1"
      },
      {
        "type": "list",
        "ids": [
          "privacy.section23.list1.item1",
          "privacy.section23.list1.item2",
          "privacy.section23.list1.item3",
          "privacy.section23.list1.item4",
          "privacy.section23.list1.item5",
          "privacy.section23.list1.item6",
          "privacy.section23.list1.item7",
          "privacy.section23.list1.item8"
        ]
      },
      {
        "type": "paragraph",
        "id": "privacy.section23.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section23.paragraph3"
      }
    ]
  },
  {
    "number": 24,
    "titleId": "privacy.section24.title",
    "blocks": [
      {
        "type": "paragraph",
        "id": "privacy.section24.paragraph1"
      },
      {
        "type": "paragraph",
        "id": "privacy.section24.paragraph2"
      },
      {
        "type": "paragraph",
        "id": "privacy.section24.paragraph3"
      },
      {
        "type": "paragraph",
        "id": "privacy.section24.paragraph4"
      },
      {
        "type": "paragraph",
        "id": "privacy.section24.paragraph5"
      },
      {
        "type": "paragraph",
        "id": "privacy.section24.paragraph6"
      },
      {
        "type": "paragraph",
        "id": "privacy.section24.paragraph7"
      }
    ]
  }
];

export default privacyNoticeStructure;
